import React from 'react'
import Logo from '../../assets/images/black-logo.png'
import OrangeBtn from '../Button/OrangeBtn'
import GrayBtn from '../Button/GrayBtn'
import '../../assets/css/CustomStyle.css'
import {
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Button,
    Card,
    Typography,
    Drawer,
    IconButton,
    Accordion,
    AccordionHeader,
    AccordionBody,
} from "@material-tailwind/react";
import { Link, NavLink } from 'react-router-dom'

export default function Header() {
    // const [WhyToromail, setWhyToromail] = React.useState(false);
    // const [Resources, setResources] = React.useState(false);
    // const [Pricing, setPricing] = React.useState(false);
    // const [Support, setSupport] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    const openDrawer = () => setOpen(true);
    const closeDrawer = () => setOpen(false);
    const [accodiopen, setaccodiopenOpen] = React.useState(0);

    const handleOpen = (value) => setOpen(open === value ? 0 : value);
    // WhyToromail
    // Resources
    // Pricing
    // Support
    return (
        <div className='1550:h-[90px] header 768:h-[80px] h-[70px] 1550:px-[6.25rem] 1440:px-[5.25rem] 1350:px-[4.25rem] 999:px-[2.9rem] 600:px-[2.5rem] px-[20px] border-b flex justify-between items-center primary-border'>
            <div className='flex items-center 1550:gap-[6.25rem] 1440:gap-[5.25rem] 1350:gap-[3.5rem] gap-[2.9rem]'>
                <NavLink to='/' className='1550:w-[150px] 1350:w-[140px] w-[11.875rem]'>
                    <img loading="lazy" src={Logo} alt='Logo' />
                </NavLink>
                <div className='999:block hidden'>
                    <ul className='flex items-center justify-start 1550:gap-[2.5rem] 1440:gap-[1.875rem]  1350:gap-[20px] gap-[10px] primary-text'>

                        {/* <li className='flex items-center justify-start 1350:gap-[10px] gap-[8px] '>
                            <Menu open={WhyToromail} handler={setWhyToromail} allowHover>
                                <MenuHandler>
                                    <Button
                                        variant="text"
                                        className="flex items-center 1350:gap-[10px] gap-[8px] normal-case text-[1.125rem] leading-[normal] praimary-text font-[450] p-0 hover:bg-transparent "
                                    >
                                        Why Toromail?{" "}
                                        <svg
                                            className={`h-[1.5rem] w-[1.5rem] transition-transform ${WhyToromail ? "rotate-180" : ""
                                                }`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="tabler:chevron-down">
                                                <path id="Vector" d="M6 9L12 15L18 9" stroke="#999CA4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </svg>
                                    </Button>
                                </MenuHandler>
                                <MenuList className="hidden  overflow-visible lg:grid">
                                    <MenuItem>!!!</MenuItem>
                                </MenuList>
                            </Menu>
                        </li> */}
                        <li>
                            <Button
                                variant="text"
                                className="flex items-center 1350:gap-[10px] gap-[8px] normal-case text-[1.125rem] leading-[normal] praimary-text font-[450] p-0 hover:bg-transparent "
                            >
                                Why Toromail?{" "}
                                {/* <svg
                                            className={`h-[1.5rem] w-[1.5rem] transition-transform ${Resources ? "rotate-180" : ""
                                                }`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="tabler:chevron-down">
                                                <path id="Vector" d="M6 9L12 15L18 9" stroke="#999CA4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </svg> */}
                            </Button>
                        </li>
                        <li>
                            <Button
                                variant="text"
                                className="flex items-center 1350:gap-[10px] gap-[8px] normal-case text-[1.125rem] leading-[normal] praimary-text font-[450] p-0 hover:bg-transparent "
                            >
                                Resources
                                {/* <svg
                                            className={`h-[1.5rem] w-[1.5rem] transition-transform ${Resources ? "rotate-180" : ""
                                                }`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="tabler:chevron-down">
                                                <path id="Vector" d="M6 9L12 15L18 9" stroke="#999CA4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </svg> */}
                            </Button>
                        </li>
                        <li>
                            <Button
                                variant="text"
                                className="flex items-center 1350:gap-[10px] gap-[8px] normal-case text-[1.125rem] leading-[normal] praimary-text font-[450] p-0 hover:bg-transparent "
                            >
                                Pricing
                              
                            </Button>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='flex items-center justify-end 1550:gap-[1.875rem]  1350:gap-[20px] gap-[10px]'>
                <ul className=' items-center 999:flex hidden justify-start 1550:gap-[2.5rem] 1440:gap-[1.875rem]  1350:gap-[20px] gap-[10px] primary-text'>
                <li>
                            <Button
                                variant="text"
                                className="flex items-center 1350:gap-[10px] gap-[8px] normal-case text-[1.125rem] leading-[normal] praimary-text font-[450] p-0 hover:bg-transparent "
                            >
                                Support
                              
                            </Button>
                        </li>
                    <li className='flex items-center justify-start 1350:gap-[10px] gap-[8px] '>
                        <Link to="">
                            <p className='text-[1.125rem] font-[450] '>Login</p>
                        </Link>
                    </li>
                </ul>

                <div className='768:flex hidden items-center justify-center 1550:gap-[20px] 1350:gap-[.9375rem] gap-[10px]'>
                    <OrangeBtn className='!1350:py-[10px] py-[8px] !px-[14px] 1350:text-[18px] !text-[14px]' value='Try for free' />
                    <GrayBtn className='!1350:py-[10px] py-[8px]  !px-[14px] 1350:text-[18px] !text-[14px]' value='Purchase now' />
                </div>

                <div className='999:hidden block'>
                    <Button aria-label='open Menu' onClick={openDrawer} className='bg-white text-[#23232d] shadow-none p-0'>
                        <svg className='lucide lucide-align-right w-[1.875rem] h-[1.875rem] text-[#23232d] bg-transparent ' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><line x1="21" x2="3" y1="6" y2="6" /><line x1="21" x2="9" y1="12" y2="12" /><line x1="21" x2="7" y1="18" y2="18" /></svg>
                    </Button>
                </div>
                <Drawer placement="right" open={open} onClose={closeDrawer} className="p-[20px] 600:w-auto w-screen">
                    <div className='h-[calc(100vh_-_40px)] relative'>
                        <div className="mb-6 flex items-center justify-between">
                            <NavLink to='/' className='1550:w-[150px] 1350:w-[140px] w-[11.875rem]'>
                                <img loading="lazy" src={Logo} alt='Logo' />
                            </NavLink>
                            <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="w-[1.875rem] h-[1.875rem] text-[#23232d] bg-transparent"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </IconButton>
                        </div>

                        <div>
                            <Accordion open={open === 1} icon={<Icon id={1} open={accodiopen} />}>
                                <AccordionHeader className='border-0 primary-text text-[16px] font-normal' onClick={() => handleOpen(1)}>Why Toromail?</AccordionHeader>
                                <AccordionBody>
                                    <ul className='space-y-2 text-[14px] font-normal'>
                                        <li>Option 1</li>
                                        <li>Option 2</li>
                                        <li>Option 3</li>
                                    </ul>
                                </AccordionBody>
                            </Accordion>
                            <Accordion open={open === 2} icon={<Icon id={2} open={accodiopen} />}>
                                <AccordionHeader className='border-0 primary-text text-[16px] font-normal' onClick={() => handleOpen(2)}>
                                    Resources
                                </AccordionHeader>
                                <AccordionBody>
                                    <ul className='space-y-2 text-[14px] font-normal'>
                                        <li>Option 1</li>
                                        <li>Option 2</li>
                                        <li>Option 3</li>
                                    </ul>
                                </AccordionBody>
                            </Accordion>
                            <Accordion open={open === 3} icon={<Icon id={3} open={accodiopen} />}>
                                <AccordionHeader className='border-0 primary-text text-[16px] font-normal' onClick={() => handleOpen(3)}>
                                    Support
                                </AccordionHeader>
                                <AccordionBody>
                                    <ul className='space-y-2 text-[14px] font-normal'>
                                        <li>Option 1</li>
                                        <li>Option 2</li>
                                        <li>Option 3</li>
                                    </ul>
                                </AccordionBody>
                            </Accordion>
                            <Accordion open={open === 4} icon={<Icon id={4} open={accodiopen} />}>
                                <AccordionHeader className='border-0 primary-text text-[16px] font-normal' onClick={() => handleOpen(4)}>
                                    Pricing
                                </AccordionHeader>
                                <AccordionBody>
                                    <ul className='space-y-2 text-[14px] font-normal'>
                                        <li>
                                            <NavLink to="/pricing">
                                                Pricing
                                            </NavLink>
                                        </li>
                                        <li>Option 1</li>
                                        <li>Option 2</li>
                                        <li>Option 3</li>
                                    </ul>
                                </AccordionBody>
                            </Accordion>
                            <Link to="">
                                <p className='text-[16px] font-normal primary-text'>Login</p>
                            </Link>
                        </div>
                        <div className='absolute bottom-0 flex items-center justify-center 1550:gap-[20px] 1350:gap-[.9375rem] gap-[10px]'>
                            <OrangeBtn className='!py-[10px] !px-[14px] 1350:text-[18px] !text-[14px]' value='Try for free' />
                            <GrayBtn className='!py-[10px] !px-[14px] 1350:text-[18px] !text-[14px]' value='Purchase now' />
                        </div>
                    </div>

                </Drawer>
            </div>
        </div>
    )
}

function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
}

export function AccordionCustomIcon() {


    return (
        <>

        </>
    );
}